import { Plus } from 'lucide-react';
import { Button } from '@sara/ui/components/button';
import { useDialog } from '@sara/ui/hooks/use-dialog';
import { useActiveOrganization } from '../../contexts/auth';
import { CreateWebhookDialog, WEBHOOK_CAP, WebhookListContainer } from '../../contexts/webhooks';
import { PageHeader } from '../../components/page-header';

export function WebhooksSettingsPage() {
  const { organization } = useActiveOrganization();
  const createDialog = useDialog(CreateWebhookDialog);

  if (!organization) return null;

  return (
    <div className="space-y-12">
      <PageHeader
        title="Webhooks"
        description={`Receive signed HTTP deliveries when sessions complete. The signing secret is shown once on creation — store it safely. Up to ${WEBHOOK_CAP} receivers per organization.`}
        action={
          <Button
            variant="tinted"
            shape="pill"
            size="sm"
            className="h-8 gap-1.5 px-3 text-xs [&_svg]:size-3.5 sm:h-9 sm:px-4 sm:text-sm sm:[&_svg]:size-4"
            onClick={() => createDialog.open({ orgId: organization.id })}
          >
            <Plus strokeWidth={1.6} />
            Add webhook
          </Button>
        }
      />

      <section>
        <WebhookListContainer
          orgId={organization.id}
          onCreate={() => createDialog.open({ orgId: organization.id })}
        />
      </section>
    </div>
  );
}
